var _defs, _rect, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentDossier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#ed0000;}.c{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1.25,
    y: 1.12,
    width: 46,
    height: 46,
    rx: 3.54,
    ry: 3.54
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "43.97 20.96 38.23 38.79 6.33 38.79 12.06 20.96 43.97 20.96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.02,14.6v4.79H11.49c-.34,0-.65.22-.75.55l-4.7,14.62V9.21h9.64l4.55,5.12c.15.17.36.27.59.27h17.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentDossier);
export default __webpack_public_path__ + "static/media/agent-dossier.75066db80ac13ffa2150ebf334a0afe7.svg";
export { ForwardRef as ReactComponent };